import { Form } from 'component'
import React from 'react'
import type { FilterFormViewProps } from './FilterFormView.types'

const FilterFormView = ({
  style,
  onSubmitForm,
  children
}: FilterFormViewProps) => {
  return (
    <Form onSubmit={onSubmitForm} style={style}>
      {children}
    </Form>
  )
}

export default FilterFormView
